import React, { useState } from "react";
import { Modal, Select, Button } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";

const { Option } = Select;

type ShareHierarchyModalProps = {
    visible: boolean;
    onClose: () => void;
    onSubmit: (selectedUsers: string[]) => void;
    featureName: string;
    accessSharedList: any[];
  };

  const ShareHierarchyModal: React.FC<ShareHierarchyModalProps> = ({ visible, onClose, onSubmit, featureName, accessSharedList }) => {
  const usersList = useSelector((store: RootState) => store.AccountReducer.allUsersList);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleOk = () => {
    if(featureName === "share") {
    onSubmit(selectedUsers);
    setSelectedUsers([]);
    } else {
      onSubmit(selectedUsers);
      setSelectedUsers([]);
    }
  };

  return (
    <Modal
      title={featureName==='share'?"Share":"Unshare"}
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} className="btn-yellow-transparent">
          Submit
        </Button>
      ]}
    >
      <Select
        className="hierarchyWorflowSelect"
        mode="multiple"
        style={{ width: "100%" }}
        placeholder="Select users"
        value={selectedUsers}
        onChange={setSelectedUsers}
      >
        {featureName==='share'?
        usersList.map(user => (
          <Option key={user.email} value={user.email}>
            {user.firstName} {user.lastName}
          </Option>
        )):
        accessSharedList.map(user => (
          <Option key={user.userId} value={user.userId}>
            {user.userId}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default ShareHierarchyModal;
